import { HTTP_INTERCEPTORS, HttpEvent, HttpHandler, HttpHeaders, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { first, mergeMap, Observable } from 'rxjs';

import { CookiesService } from '@utils/services/cookies.service';
import { oficinaSelected } from '@core/store/selectors/oficinas.selectors';
import { AppState } from '@core/store';
import { Store } from '@ngrx/store';

@Injectable({
	providedIn: 'root',
})
export class AuthInterceptorService implements HttpInterceptor {
	constructor(private readonly cookiesService: CookiesService, private readonly store: Store<AppState>) {}

	intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		let clonedRequest;
		if (req.url.indexOf('sumax-erp-backend-maestros-sync') != -1 || req.url.indexOf('sumax-erp-backend-control-clientes') != -1) {
			clonedRequest = this.cookiesService.getBearerAuthorization('maestroSyncToken');
			let headers = new HttpHeaders({ Authorization: clonedRequest });
			return next.handle(req.clone({ headers }));
		} else {
			clonedRequest = this.cookiesService.getBearerAuthorization('idToken');
			return this.store.select(oficinaSelected).pipe(
				first(),
				mergeMap((res) => {
					const headerObject = { Authorization: clonedRequest };
					if (res?.idOficina && !req.url.includes('prod/sumax-erp-backend-reportes')) {
						headerObject['idOficina'] = res.idOficina.toString();
					}
					let headers = new HttpHeaders(headerObject);
					return next.handle(req.clone({ headers }));
				})
			);
		}
	}
}

export const authInterceptorProviders = {
	provide: HTTP_INTERCEPTORS,
	useClass: AuthInterceptorService,
	multi: true,
};
